<template>
    <div class="menu-wrapper">
        <!-- Menu Navigation -->
        <MenuNavigation
        :selectedCategory="selectedCategory"
        :categories="categories"
        @clicked="setCategory"
        />
        <!-- Menu Columns -->
        <MenuColumns
        :category="selectedCategory"
        :dishes="selectedDishes"
        />
    </div>
</template>

<script>
import MenuNavigation from '@/components/menu/MenuNavigation'
import MenuColumns from '@/components/menu/MenuColumns'


export default {
    props: ['categories', 'dishes'],
    components: {
        MenuNavigation,
        MenuColumns
    },
    methods: {
        setCategory: function(category) {
            this.selectedCategory = category
            this.selectedDishes = this.getDishesByCategory(category.id)
        },
        getDishesByCategory: function() {
            return this.dishes.items.filter(x => x.category_id === this.selectedCategory.id)
        }
    },
    created () {
        // First init dishes
        this.selectedDishes = this.getDishesByCategory(this.selectedCategory.id)
    },
    data () {
        return {
            selectedCategory: this.categories.items[0],
            selectedDishes: null
        }
    },
    watch: {
      categories(newVal) {
        this.selectedCategory = newVal.items[0]
      },
      dishes() {
        this.selectedDishes = this.getDishesByCategory(this.selectedCategory.id)
      }
    },
}
</script>
